import React from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import formTypes from 'components/HomePage/formTypeSelectValues';

const AdvancedSearchPanel = ({ title, searchCriteria, onSearchClicked, onSearchCriteriaChanged, clientList, isMultiDbAndViewingTable }) => {
  const onSearchClick = () => {
    onSearchClicked(searchCriteria);
  };

  return (
    <div className="panel search-panel">
      <div className="panel-header">
        <div className="panel-title">
          { title }
        </div>
      </div>
      <div className="panel-body">
        <div className="row search-row">
          <div className="col-2 p-2">
            <select
              id="client-select"
              className="form-select"
              value={ searchCriteria.clientIds === null ? '' : String(searchCriteria.clientIds) }
              onChange={ (e) => {
                onSearchCriteriaChanged({ ...searchCriteria, clientIds: e.target.value === '' ? null : [Number(e.target.value)] });
              } }
              disabled={ isMultiDbAndViewingTable }
            >
              <option key="" value="">All Clients</option>
              {clientList.map((option, i) => (
                <option key={ String(option.key) } value={ String(option.key) }>
                  {option.value}
                </option>
              ))}
            </select>
          </div>
          <div className="col-2 p-2">
            <input
              className="form-input"
              type="search"
              name="customerIdSearch"
              placeholder="Customer ID"
              value={ searchCriteria.customerIdentifier }
              onChange={ (e) => {
                onSearchCriteriaChanged({ ...searchCriteria, customerIdentifier: e.target.value });
              } }
            />
          </div>
          <div className="col-2 p-2">
            <input
              className="form-input"
              type="search"
              name="customerNameSearch"
              placeholder="Customer Name"
              value={ searchCriteria.customerName ?? '' }
              onChange={ (e) => {
                onSearchCriteriaChanged({ ...searchCriteria, customerName: e.target.value });
              } }
            />
          </div>
          <div className="col-2 p-2">
            <input
              className="form-input"
              type="search"
              name="accountNumberSearch"
              placeholder="Account Number"
              value={ searchCriteria.accountNumber ?? '' }
              onChange={ (e) => {
                onSearchCriteriaChanged({ ...searchCriteria, accountNumber: e.target.value });
              } }
            />
          </div>
          <div className="col-2 p-2">
            <input
              className="form-input"
              type="search"
              name="accountNameSearch"
              placeholder="Account Name"
              value={ searchCriteria.accountName ?? '' }
              onChange={ (e) => {
                onSearchCriteriaChanged({ ...searchCriteria, accountName: e.target.value });
              } }
            />
          </div>
          <div className="col-2 p-2">
            <select
              id="form-type"
              className="form-select"
              value={ searchCriteria.formType }
              onChange={ (e) => {
                onSearchCriteriaChanged({ ...searchCriteria, formType: e.target.value });
              } }
            >
              <option value="">All Forms</option>
              {formTypes.map((option, i) => (
                <option key={ option.value } value={ option.value }>
                  {option.description}
                </option>
              ))}
            </select>
          </div>
          <div className="col p-2">
            <button
              id="search-btn"
              type="button"
              className="btn btn-primary search-btn"
              onClick={ () => onSearchClick() }
            >
              <span className="icon icon-search" />
              <span> Search</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

AdvancedSearchPanel.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string
  ]),
  searchCriteria: PropTypes.shape().isRequired,
  onSearchClicked: PropTypes.func.isRequired,
  onSearchCriteriaChanged: PropTypes.func.isRequired,
  clientList: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.number.isRequired,
      value: PropTypes.string.isRequired,
      isPiiProtectionEnabled: PropTypes.bool.isRequired,
    })
  ).isRequired,
  isMultiDbAndViewingTable: PropTypes.bool
};

AdvancedSearchPanel.defaultProps = {
  title: 'Search',
  isMultiDbAndViewingTable: false
};

const SearchPanelForm = reduxForm({
  form: 'searchForm',
})(AdvancedSearchPanel);

const mapDispatchToProps = dispatch => ({ dispatch });

const ConnectedSearchPanel = connect(
  null,
  mapDispatchToProps
)(SearchPanelForm);

export default ConnectedSearchPanel;
